import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import {
  adjustmentsRequest,
  onClickRow,
  onClickRowIngredientAdjustment,
  ingredientAdjustmentsRequest,
} from 'actions/inventory/adjustment';
import { getFormValues, isDirty } from 'redux-form';
import moment from 'moment';
import _ from 'lodash';
import { askConfirmAction } from 'actions/confirm-action';
import { currencyFormatter } from 'utils/formatter';
import styles from './List.css';

class List extends React.Component {
  static INGREDIENTS = 'ingredients';

  static ITEMS = 'items';

  render() {
    return (
      this._hasData() && (
        <div className={styles.wrapper}>
          <table className={styles['table-header']}>
            {this._namespace() === List.ITEMS && this._renderAdjustmentHeader()}
            {this._namespace() === List.INGREDIENTS &&
              this._renderIngredientAdjustmentHeader()}
          </table>
          <div
            className={`${
              styles['table-content-wrapper']
            } adjustment-table-content-wrapper`}
          >
            <InfiniteScroll
              pageStart={1}
              loadMore={this._onReachBottom}
              hasMore={this._hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}
            >
              <table className={`${styles['table-content']}`}>
                {this._namespace() === List.ITEMS &&
                  this._renderAdjustmentTable()}
                {this._namespace() === List.INGREDIENTS &&
                  this._renderIngredientAdjustmentTable()}
              </table>
            </InfiniteScroll>
          </div>
        </div>
      )
    );
  }

  _renderAdjustmentHeader = () => {
    const { search } = this.props;
    return (
      <thead>
        <tr>
          <th>Date</th>
          <th>{search && search.outletIds.length > 1 && 'Outlet'}</th>
          <th>Note</th>
          <th className="text-center">Items</th>
          <th className="text-center">Adjustment</th>
          <th className="text-center">Expense/Income</th>
        </tr>
      </thead>
    );
  };

  _renderIngredientAdjustmentHeader = () => {
    const { search } = this.props;
    return (
      <thead>
        <tr>
          <th>Date</th>
          <th>{search && search.outletIds.length > 1 && 'Outlet'}</th>
          <th>Note</th>
          <th className="text-center">Ingredient</th>
          <th className="text-right">Adjustment</th>
          <th className="text-center">Expense/Income</th>
        </tr>
      </thead>
    );
  };

  _renderAdjustmentTable = () => {
    const { adjustments, adjustmentDetail, search } = this.props;

    return (
      <tbody>
        {adjustments.map((adjustment, index) => {
          const className = `${
            adjustmentDetail && adjustmentDetail.id === adjustment.id
              ? styles.selected
              : ''
          }`;
          if (adjustment.isdaterow) {
            return (
              <tr key={index}>
                <td colSpan={6} className={styles.parentRow}>
                  {moment(adjustment.created_at).format('ddd MMM DD YYYY')}
                </td>
              </tr>
            );
          }
          return (
            <tr
              key={adjustment.id}
              onClick={() => {
                this._onClickRowAdjustment(adjustment);
              }}
              className={className}
            >
              <td>{moment(adjustment.created_at).format('HH:mm')}</td>
              <td>
                {search &&
                  search.outletIds.length > 1 &&
                  adjustment.outlet.name}
              </td>
              <td>{this._noteAdjustment(adjustment)}</td>
              <td className="text-center">
                {this._itemNameAdjustment(adjustment)}
              </td>
              <td className="text-center">
                {this._totalAdjustment(adjustment)}
              </td>
              <td className="text-center">
                {this._totalExpenseIncome(adjustment) !== 0 &&
                  currencyFormatter(this._totalExpenseIncome(adjustment))}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };

  _renderIngredientAdjustmentTable = () => {
    const {
      ingredientAdjustments,
      ingredientAdjustmentDetail,
      search,
    } = this.props;

    return (
      <tbody>
        {ingredientAdjustments.map((ingAdj, index) => {
          const className = `${
            ingredientAdjustmentDetail &&
            ingredientAdjustmentDetail.id === ingAdj.id
              ? styles.selected
              : ''
          }`;
          if (ingAdj.isdaterow) {
            return (
              <tr key={index}>
                <td colSpan={6} className={styles.parentRow}>
                  {moment(ingAdj.created_at).format('ddd MMM DD YYYY')}
                </td>
              </tr>
            );
          }
          return (
            <tr
              key={ingAdj.id}
              onClick={() => {
                this._onClickRowIngredientAdjustment(ingAdj);
              }}
              className={className}
            >
              <td>{moment(ingAdj.created_at).format('HH:mm')}</td>
              <td>
                {search && search.outletIds.length > 1 && ingAdj.outlet.name}
              </td>
              <td>{this._noteIngredientAdjustment(ingAdj)}</td>
              <td className="text-center">{this._ingredientName(ingAdj)}</td>
              <td className="text-right">
                {this._totalIngredientAdjustment(ingAdj)}
              </td>
              <td className="text-center">
                {currencyFormatter(this._totalExpenseIncomeIngredient(ingAdj))}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };

  _onReachBottom = () => {
    const {
      dispatch,
      currentPage,
      adjustments,
      ingredientAdjustments,
      search: { date, namespace },
    } = this.props;
    const { startDate, endDate } = date;
    const params = {
      page: currentPage + 1,
      start: startDate.format('YYYY-MM-DD'),
      end: endDate.format('YYYY-MM-DD'),
    };
    if (namespace === List.INGREDIENTS) {
      dispatch(ingredientAdjustmentsRequest(params, ingredientAdjustments));
    } else {
      dispatch(adjustmentsRequest(params, adjustments));
    }
  };

  _itemNameAdjustment = adjustment => {
    // check apakah semua itemnya sama
    const itemIds = _.countBy(adjustment.history_details, 'item_id');
    if (Object.keys(itemIds).length > 1) {
      return `${adjustment.history_details.length} items`;
    }
    if (!adjustment.history_details[0].item_variant_name) {
      return `${adjustment.history_details[0].item_name}`;
    }
    return `${adjustment.history_details[0].item_name} (${adjustment.history_details.length} variants)`;
  };

  _ingredientName = ingredientAdjustment => {
    if (ingredientAdjustment.ingredient_history_details.length === 1) {
      return ingredientAdjustment.ingredient_history_details[0].ingredient_name;
    }
    return `${ingredientAdjustment.ingredient_history_details.length} ingredients`;
  };

  _totalAdjustment = adjustment => {
    let total = 0;
    adjustment &&
      adjustment.history_details.forEach(hd => {
        total += hd.end_stock - hd.beginning_stock;
      });
    return total;
  };

  _totalIngredientAdjustment = ingredientAdjustment => {
    let total = 0;
    // check apakah semua unitnya sama
    const unitIds = _.countBy(
      ingredientAdjustment.ingredient_history_details,
      'unit_id'
    );
    let unitName = '';
    if (Object.keys(unitIds).length > 1) {
      return 'Multiple Adjusted';
    }
    ingredientAdjustment.ingredient_history_details.forEach(hd => {
      total += hd.adjustment_quantity;
      unitName = hd.unit_name;
    });
    return `${Number(total).toFixed(2)} ${unitName}`;
  };

  _noteAdjustment = adjustment => {
    if (adjustment.note) {
      return adjustment.note;
    }
    return '-';
  };

  _noteIngredientAdjustment = ingredientAdjustment => {
    if (ingredientAdjustment.note) {
      return ingredientAdjustment.note;
    }
    return '-';
  };

  _onClickRowAdjustment = adjustment => {
    const { dispatch, isDirtyForm } = this.props;
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickRow(adjustment)));
    } else {
      dispatch(onClickRow(adjustment));
    }
  };

  _onClickRowIngredientAdjustment = ingredientAdjustment => {
    const { dispatch, isDirtyForm } = this.props;
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(onClickRowIngredientAdjustment(ingredientAdjustment))
      );
    } else {
      dispatch(onClickRowIngredientAdjustment(ingredientAdjustment));
    }
  };

  _hasData = () => {
    const { adjustments, ingredientAdjustments } = this.props;
    if (this._namespace() === List.INGREDIENTS) {
      return ingredientAdjustments.length > 0;
    }
    if (this._namespace() === List.ITEMS) {
      return adjustments.length > 0;
    }
    return adjustments.length > 0;
  };

  _namespace = () => {
    const { search } = this.props;
    if (search) {
      const { namespace } = search;
      return namespace;
    }
    return '';
  };

  _totalExpenseIncome = adjustment => {
    let expenseIncome = 0;
    adjustment.history_details.forEach(hd => {
      if (hd.cogs) {
        expenseIncome += hd.cogs * hd.adjustment;
      }
    });
    return expenseIncome;
  };

  _totalExpenseIncomeIngredient = ingAdj => {
    let expenseIncomeIngredient = 0;
    ingAdj.ingredient_history_details.forEach(hd => {
      if (hd.cogs) {
        expenseIncomeIngredient += hd.cogs * hd.adjustment_quantity;
      }
    });
    return expenseIncomeIngredient;
  };
}

function mapStateToProps(state) {
  const {
    adjustments,
    adjustmentDetail,
    currentPage,
    totalPage,
    outlets,
    ingredientAdjustments,
    ingredientAdjustmentDetail,
  } = state.inventory.adjustment;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    adjustments,
    ingredientAdjustments,
    ingredientAdjustmentDetail,
    adjustmentDetail,
    currentPage,
    totalPage,
    showLoadingSpinnerPage,
    search: getFormValues('search')(state),
    isDirtyForm: isDirty('adjustment')(state),
    outlets,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

List.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
